import client from './client';

// === OPERATOR endpoints (for logged-in operator) ===
export async function getDashboard() {
  const response = await client.get('/operator/dashboard');
  return response.data;
}

export async function getSettings() {
  const response = await client.get('/operator/settings');
  return response.data;
}

export async function updateSettings(settings) {
  const response = await client.put('/operator/settings', { settings });
  return response.data;
}

export async function getPrizeTemplates() {
  const response = await client.get('/operator/prize-templates');
  return response.data;
}

export async function createPrizeTemplate(data) {
  const response = await client.post('/operator/prize-templates', data);
  return response.data;
}

export async function updatePrizeTemplate(id, data) {
  const response = await client.put(`/operator/prize-templates/${id}`, data);
  return response.data;
}

export async function deletePrizeTemplate(id) {
  const response = await client.delete(`/operator/prize-templates/${id}`);
  return response.data;
}

// === ADMIN endpoints (admin only) ===
export async function getAdminDashboard() {
  const response = await client.get('/admin/dashboard');
  return response.data;
}

export async function getUsers() {
  const response = await client.get('/admin/users');
  return response.data;
}

export async function createUser(data) {
  const response = await client.post('/admin/users', data);
  return response.data;
}

export async function updateUser(id, data) {
  const response = await client.put(`/admin/users/${id}`, data);
  return response.data;
}

export async function deleteUser(id) {
  const response = await client.delete(`/admin/users/${id}`);
  return response.data;
}

export async function toggleUserActive(id) {
  const response = await client.post(`/admin/users/${id}/toggle-active`);
  return response.data;
}
